/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { events } from './events/index';
import { components } from './components/index';

const RiskDetailsFacilitySection = {
  events,
  components
};

export { RiskDetailsFacilitySection }